import { createContext, useState } from "react";

const KpiContext = createContext({});

export const KpiProvider = ({ children }) => {
  const [tabs, setTabs] = useState(1);

  return (
    <KpiContext.Provider value={{ tabs, setTabs }}>
      {children}
    </KpiContext.Provider>
  );
};

export default KpiContext;
